(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pihot-oas-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('p-oas-help')) {
    customElements.define('p-oas-help', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const dialog = this.closest('fieldset')?.querySelector('[data-oas-dialog]');
          if (!dialog || typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          if (dialog.open) return;
          this.dialog = dialog;
          this.trigger = link;
          this.previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          if (!this.bound) {
            this.bound = true;
            dialog.querySelector('[data-oas-close]').addEventListener('click', () => dialog.close(), { signal: this.abort.signal });
            dialog.addEventListener('click', (click) => {
              if (click.target !== dialog) return;
              const box = dialog.getBoundingClientRect();
              if (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom) dialog.close();
            }, { signal: this.abort.signal });
            dialog.addEventListener('close', () => {
              document.body.style.overflow = this.previousOverflow;
              if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
            }, { signal: this.abort.signal });
          }
          dialog.querySelector('.p-oas-dialog__body').scrollTop = 0;
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.body.style.overflow = this.previousOverflow;
        }
        this.abort?.abort();
        this.bound = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
